import { makeStyles } from 'tss-react/mui';
import { ToggleButtonGroup } from '@mui/material';
import { ButtonStyleRadio } from '@uplift/ui-v2';

export type StepToggleButtonGroupProps = {
  children: React.ReactNode;
  onChange: (event: React.MouseEvent<HTMLElement>, value: string) => void;
};

export const StepToggleButtonGroup: React.FC<StepToggleButtonGroupProps> = ({ children, ...props }) => {
  const { classes } = useStepToggleButtonGroupStyles();

  return (
    <ToggleButtonGroup
      className={classes.root}
      exclusive
      orientation="vertical"
      {...props}
    >
      {children}
    </ToggleButtonGroup>
  );
};

const useStepToggleButtonGroupStyles = makeStyles({ name: 'StepToggleButtonGroup' })({
  root: {
    width: '100%',
  },
});

export type StepToggleButtonProps = {
  value: string;
  children: React.ReactNode;
  disabled?: boolean;
};

export const StepToggleButton: React.FC<StepToggleButtonProps> = ({ children, ...props }) => {
  const { classes } = useStepToggleButtonStyles();

  return (
    <ButtonStyleRadio
      classes={classes}
      color="secondary"
      {...props}
    >
      {children}
    </ButtonStyleRadio>
  );
};

const useStepToggleButtonStyles = makeStyles({ name: 'StepToggleButton' })({
  root: {
    height: '56px',
    fontSize: '15px',
    textTransform: 'none',
    fontWeight: 400,
    justifyContent: 'flex-start',
  },
});
